import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Logo from '../assets/logo.svg'; // Import logo

interface PaymentCancelProps {}

const PaymentCancelPage: React.FC<PaymentCancelProps> = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(15);
  
  useEffect(() => {
    // Set up countdown for redirect
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/visit', { replace: true });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    
    return () => clearInterval(timer);
  }, [navigate]);
  
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-2xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden">
        {/* Warning header */}
        <div className="bg-yellow-500 px-6 py-4 text-white">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <img src={Logo} alt="Scribedo Logo" className="h-6 bg-white rounded p-0.5" />
              <h2 className="text-lg font-bold">Payment Cancelled</h2>
            </div>
          </div>
        </div>
        
        {/* Content */}
        <div className="p-6">
          <div className="text-center mb-8">
            <svg className="h-16 w-16 text-yellow-500 mx-auto mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h3 className="text-2xl font-bold text-gray-800 mb-2">Your payment was not completed</h3>
            <p className="text-gray-600 max-w-md mx-auto">
              You've cancelled the payment process. Your subscription has not been activated, and no charges were made to your account.
            </p>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-5 mb-6">
            <h4 className="font-medium text-gray-800 mb-3">Common reasons for cancellation:</h4>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-start">
                <svg className="h-5 w-5 text-gray-400 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Changed your mind about the subscription plan</span>
              </li>
              <li className="flex items-start">
                <svg className="h-5 w-5 text-gray-400 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Payment method issues or expired card</span>
              </li>
              <li className="flex items-start">
                <svg className="h-5 w-5 text-gray-400 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Needed to review plan details before proceeding</span>
              </li>
            </ul>
          </div>
          
          <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3">
            <Link
              to="/pricing"
              className="flex-1 bg-[#0078d4] text-white px-4 py-3 rounded text-center font-medium hover:bg-[#106ebe] focus:outline-none focus:ring-2 focus:ring-[#0078d4] focus:ring-offset-2"
            >
              Try Again
            </Link>
            <Link
              to="/visit"
              className="flex-1 bg-white text-gray-700 border border-gray-300 px-4 py-3 rounded text-center font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2"
            >
              Go to Visit Page
            </Link>
          </div>
          
          <div className="mt-8 text-center text-sm text-gray-500">
            <p>You'll be redirected to plans page in <span className="font-bold">{countdown}</span> seconds</p>
            <p className="mt-2">
              Need help? <a href="#" className="text-[#0078d4] font-medium hover:underline">Contact our support team</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage; 